import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowRight, Users, Baby, GraduationCap, UserRound, Brain, Activity } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ICONS = {
  infantil_0_2: Baby,
  infantil_2_4: Baby,
  infantil_4_5: Baby,
  infantil_6: GraduationCap,
  juvenil_7_20: Users,
  adulto: UserRound,
  dano_cerebral: Brain,
  sdp: Activity,
};

const QuestionnaireListPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/questionnaires`).then((r) => {
      setItems(r.data);
      setLoading(false);
    });
  }, []);

  return (
    <main className="min-h-[70vh]" data-testid="questionnaires-list-page">
      <section className="py-20 px-6" style={{ background: "var(--bg-soft)" }}>
        <div className="max-w-5xl mx-auto text-center fade-up">
          <span className="section-eyebrow">Cuestionario pre-cita</span>
          <h1 className="section-title mt-4">Elige tu <span className="handwritten">cuestionario</span></h1>
          <p className="font-sans-body text-[color:var(--ink-soft)] mt-5 max-w-2xl mx-auto">
            Estos cuestionarios nos ayudan a conocerte mejor antes de tu cita. Selecciona el que corresponda a tu edad o al cuestionario especializado que te hayamos indicado. La información es confidencial y solo será consultada por el equipo clínico.
          </p>
          <p className="font-sans-body text-xs text-[color:var(--sage-600)] mt-4 inline-flex items-center gap-1.5">
            ✦ Las respuestas se guardan automáticamente — puedes pausar y continuar cuando quieras
          </p>
        </div>
      </section>

      <section className="py-16 px-6">
        <div className="max-w-6xl mx-auto">
          {loading ? (
            <p className="text-center font-sans-body text-[color:var(--ink-soft)]">Cargando...</p>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="questionnaires-grid">
              {items.map((q, i) => {
                const Icon = ICONS[q.id] || Users;
                return (
                  <Link key={q.id} to={`/cuestionarios/${q.id}`} className="soft-card fade-up group block" style={{ animationDelay: `${0.05 * i}s` }} data-testid={`questionnaire-card-${q.id}`}>
                    <div className="h-12 w-12 rounded-full flex items-center justify-center mb-5 transition-colors group-hover:bg-[color:var(--sage-200)]" style={{ background: "var(--sage-50)" }}>
                      <Icon size={22} style={{ color: "var(--sage-600)" }} />
                    </div>
                    <div className="section-eyebrow">{q.age_range}</div>
                    <h3 className="text-xl font-medium mt-2" style={{ color: "var(--ink)" }}>{q.title}</h3>
                    <p className="mt-2 font-sans-body text-sm text-[color:var(--ink-soft)]">{q.description}</p>
                    <div className="mt-5 inline-flex items-center gap-2 text-sm font-medium" style={{ color: "var(--sage-600)" }}>
                      Comenzar <ArrowRight size={16} />
                    </div>
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default QuestionnaireListPage;
